import { useMutation } from "@tanstack/react-query";
import { VideoAddParams, videoAdd } from "common/api/unos_rad/unos_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosVideoAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
};

export const useUnosVideoAdd = (hookParams?: UseUnosVideoAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoAddMutate } = useMutation({
    mutationFn: async (videoAddParams: VideoAddParams) =>
      await videoAdd(videoAddParams),
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
  });

  return { videoAddMutate };
};
